<template>
<div>
    <v-row>
        <v-col cols="3" align-self="center" class=" pe-1">
            <v-autocomplete
                v-model="cityIdSpecialtyCount"
                :items="cities"
                item-text="name"
                item-value="id"
                :label="$t('inputs.city')"
                outlined
                hide-details
                dense
                :loading="loading"
                :disabled="loadingSpecialtyCount || loading"
            />
        </v-col>

        <v-col cols="2" align-self="center" class="pe-1">
            <v-btn 
                @click="getSpecialtyCountInCity()" 
                color="success" 
                small 
                class="text-none"
                :disabled="loading || submitLoading || loadingSpecialtyCount"
                :loading="loadingSpecialtyCount"
                
            >
                {{$t('search')}}
            </v-btn>
        </v-col>
    </v-row>
    <v-card class="scroll-style">
        <v-card-text>
            <v-expansion-panels>
                <v-expansion-panel
                    v-for="(item,i) in specialtiesInCity?.customersSpecs"
                    :key="i"
                >
                    <v-expansion-panel-header>
                        <div class="d-flex justify-space-between">
                            <h5>
                                {{ getSpecialtyById(item.specialtyId)?.name }} 
                            </h5>
                            <span class="success--text font-weight-bold">
                                {{ item.entitiesSpecCount }}
                            </span>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-data-table
                            :headers="[ { text: 'workload', value: 'workload' }, { text: 'count', value: 'count' } ]"
                            :items="item.totalCount"
                            dense
                            hide-default-footer
                            :items-per-page="-1"
                        >
                            <template v-slot:item.workload="{ item }">
                                {{ getClassificationById(item.workloadId)?.name || '-' }}
                            </template>

                            <template v-slot:item.count="{ item }">
                                <h5 class="success--text">
                                    {{ item.totalCount }}
                                </h5>
                            </template>
                        </v-data-table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <!-- <apexchart type="bar" height="1200" :options="chartOptions" :series="series"></apexchart> -->
        </v-card-text>
    </v-card>

</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
    data() {
        return {
            loadingSpecialtyCount: false,
            cityIdSpecialtyCount: null,
            specialtiesInCity: [],
            loading: false,
            submitLoading: false
        }
    },

    computed: {
        ...mapState({
            specialties: state => state.specialties.specialties,
            classification: state => state.workload.classification,
            cities: state => state.cities.cities,
        }),

        ...mapGetters({
            getClassificationById: 'workload/getClassificationById',
            getMaterialById: 'materials/getMaterialById',
            getTeamById: 'teams/getTeamById',
            getRegionAllById: 'regions/getRegionAllById',
            getRoleById: 'rolePermission/getRoleById',
            getSpecialtyById: 'specialties/getSpecialtyById'
        }),

		series(){
			const workloadData = [];
			if (this.specialtiesInCity && this.specialtiesInCity.customersSpecs) {
				this.specialtiesInCity.customersSpecs.forEach(spec => {
					if (spec) {
						spec.totalCount.forEach(workload => {
							workloadData.push({
								name: workload.workloadId,
								data: [workload.totalCount]
							});
						});
					}
				});
			}
			return workloadData
		},

        chartOptions() {
			return {
				chart: {
					type: 'bar',
					height: 350,
					stacked: true,
				},
				plotOptions: {
					bar: {
						horizontal: true,
						dataLabels: {
							total: {
								enabled: true,
								offsetX: 0,
								style: {
								fontSize: '13px',
								fontWeight: 900
								}
							}
						}
					},
				},
				stroke: {
					width: 1,
					colors: ['#fff']
				},
				title: {
					text: 'Fiction Books Sales'
				},
				xaxis: {
					categories: this.specialtiesInCity?.customersSpecs?.map(spec => (spec.specialtyId)),
					labels: {
						formatter: function (val) {
							return val + "K"
						}
				  	}
				},
				yaxis: {
					title: {
						text: undefined
					},
				},
				tooltip: {
					y: {
						formatter: function (val) {
						return val + "K"
						}
				  	}
				},
				fill: {
					opacity: 1
				},
				legend: {
					position: 'top',
					horizontalAlign: 'left',
					offsetX: 40
				}
			}
		},
        
    },

    methods: {
        getSpecialtyCountInCity() {
            this.loadingSpecialtyCount = true
            this.$store.dispatch('statisticsHome/fetchSpecialtyCountInCity', {  
                cityId: this.cityIdSpecialtyCount
            }).then((data) => {
                this.specialtiesInCity = data
                console.log(data)
            }).finally(() => {
                this.loadingSpecialtyCount = false
            })
        }
    },

    created(){
        this.loadingSpecialtyCount = true
        Promise.all([
            !this.cities.length ? this.$store.dispatch('cities/fetchCityMine', {}) : null,
            !this.specialties.length ? this.$store.dispatch('specialties/fetchAll') : null,
            !this.classification.length ? this.$store.dispatch('workload/fetchAll') : null
        ]).finally(() => {
            this.loadingSpecialtyCount = false
        })
    }
}
</script>

<style scoped>
</style>
